<template>

  <div class="tp-wrapper" v-if="personData">

    <div class="person">
      <div class="admin-wrap" id="admin-wrap">
        <div class="admin-link" id="adminLink" ref="adminLink">
          <a :href="'/admin/persons_published?id=' + personData.id" target="_blank">Редактировать персону</a>
        </div>
      </div>
      <h2 class="person-title">{{ personData.title }}</h2>
      <div class="person-wrap">
        <div class="person-img">
          <img :src="personData.image"
               class="person-img__picture" alt="">
        </div>
        <div class="person-description">
          <div class="person-description-text" v-html="personData.description"></div>
        </div>
      </div>
      <div class="person-previews">
        <div class="tp-nav__season-title">
          {{ personData.title }} на Teleportal
        </div>
        <div class="tp-show__list">
          <swiper class="tp-show__list foo" ref="mySwiper" :options="swiperOptions" :auto-update="false">
            <swiper-slide class="tp-show__list-item tp-show__list-item_nodescr"
                          v-for='(item, index) in personData.projects'
                          v-bind:key="index">
              <div class="hover-block">
                <router-link :to="'/'  + $store.state.lang + '/' + item.typeSlug +
                 '/' + item.channelSlug +
                  '/' + item.projectSlug">
                  <div class="tp-show__list-item__thumb">
                    <img :src="item.image" style="opacity: 1;"
                         :alt="personData.title">

                  </div>
                </router-link>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </div>
    <foot v-if="this.personData"></foot>
  </div>
</template>

<script>

import axios from "axios";
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
import config from "../../public/js/config";
import Foot from "@/components/footer";

export default {
  name: "person",
  data() {
    return {
      personData: null,
      personSlug: this.$route.params.personSlug,
      swiperOptions: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        loop: false,
        allowTouchMove: true,
        allowSlideNext: true,
        allowSlidePrev: true,
        initialSlide: 0,
        speed: 500,
        slidesPerView: 'auto',
        spaceBetween: 0,
        watchOverflow: true,
        autoplay: false,
        // preloadImages: true,
        // watchSlidesProgress: true,
        breakpoints: {
          768: {
            slidesPerGroup: 3,
            spaceBetween: 0,
            allowTouchMove: false,
            slidesPerView: 'auto',
            speed: 500,
            // freeMode: true,
            // grabCursor: true,
          }
        }
      }
    };
  },
  components: {
    Foot,
    Swiper,
    SwiperSlide,
  },
  metaInfo() {
    if (this.personData) {
      return {
        title: this.personData.seoTitle,
        meta: [
          {
            name: 'description',
            content: this.personData.seoDescription
          },
          {name: 'keywords', content: this.personData.seoKeywords}
        ]
      }
    }
  },
  created() {
    this.fetchData()
    window.addEventListener('keyup', this.addVisibleClass)
  },
  destroyed() {
    window.removeEventListener('keyup', this.addVisibleClass)
  },
  watch: {
    $route: 'fetchData'
  },
  mounted() {

  },
  methods: {
    fetchData() {
      axios.get(config.VUE_APP_API_BASE_URL + `/${this.$store.state.lang}/` +
          'person/' + this.personSlug, {})
          .then(response => (this.personData = response.data))
          .catch(err => {
            if (err) {
              console.log(err)
              window.location.href = '/' + this.$store.state.lang + '/404'
            }
          })
    },
    addVisibleClass(e) {
      let adminLink = document.getElementById('admin-wrap')
      if(e.ctrlKey && e.keyCode === 69 && e.keyCode === 69) {
        adminLink.classList.toggle('thisIsVisible')
      }
    }
  },

  computed: {},
}
</script>

<style scoped lang="less">

.admin-wrap {
  position: fixed;
  display: none;
  color: @white;
  font-size: 16px;
  top: 100px;
  right: 0;

}
.admin-link {
  padding: 10px;
  background: dimgrey;

  & a {
    color: @white;
    text-decoration: none;
  }
}

.thisIsVisible {
  display: block;
  z-index: 12345;
}

.person {
  max-width: inherit;
  padding: 0 65px;
  display: block;
  margin: 80px auto 0;
  overflow-y: initial;
  width: 100%;
  //max-width: 1260px;

  & ::v-deep table {
    border-collapse: collapse;
  }

  &-wrap {
    display: flex;
    flex-direction: row;
  }

  &-img {
    min-width: 280px;
    min-height: 418px;
    max-width: 280px;
    max-height: 418px;
    display: inline-block;
    vertical-align: top;
    width: 30%;
    overflow: hidden;
    margin: 0;

    &__picture {
      display: block;
      width: 100%;
    }
  }

  &-title {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 52px;
    font-weight: normal;
    margin-bottom: 35px;
    color: #fff;
  }

  &-description {
    font-family: Arial, Helvetica, sans-serif;
    width: 100%;
    display: inline-block;
    margin: -7px 0 0 25px;
    vertical-align: top;
    font-size: 16px;
    font-weight: 400;
    color: #afaeae;

    & ::v-deep table,
    & ::v-deep th,
    & ::v-deep tr,
    & ::v-deep td {

      border: 1px solid grey;
    }

    & ::v-deep table {
      width: 100% !important;

      & ::v-deep tr {
        & ::v-deep td:last-child {
          width: 75%;
        }
      }
    }

    &-text {
      margin-bottom: 25px;
    }

    & ::v-deep p {
      margin: 0;
      padding: 0;
    }

    & ::v-deep a {
      color: #0275d8;

      &:hover {
        color: #014c8c;
      }
    }
  }

  &-previews {
    margin-top: 50px;
    border-top: 1px solid #6b6866;

    & .tp-show__list {
      margin-left: 0;
    }

    & .tp-nav__season-title {
      margin: 20px 0 0;
    }
  }
}


@media (max-width: 1259px) {


  .person {

    &-img {
      width: 100%;
      margin: 0 auto 0;
      display: block;
      max-width: 280px;
      max-height: 418px;
    }

    &-description {
      display: block;
      width: 100%;
      margin: 20px 0;
      padding: 0 10px;
    }

    &-title {
      margin-top: 80px;
      text-align: center;
    }
  }


}

@media (max-width: 1200px) {


  .person {
    max-width: inherit;
    padding: 0 15px;

    &-wrap {
      display: flex;
      flex-direction: column;
    }

    &-img {
      min-width: 280px;
      min-height: 418px;
      margin: 0 auto;
    }

    &-title {
      font-family: Arial, Helvetica, sans-serif;
    }

    &-description {
      width: 100%;
      margin: 40px 0;
      font-family: Arial, Helvetica, sans-serif;
    }
  }
}

@media (max-width: 768px) {
  .person {
    display: block;
    margin: 50px auto 0;
    overflow-y: initial;
    width: 100%;
    max-width: 1260px;

    &-img {
      width: 100%;
      margin: 0 auto 0;
      display: block;
      max-width: 280px;
      max-height: 418px;
    }

    &-description {
      display: block;
      width: 100%;
      margin: 20px 0;
      padding: 0 10px;

      & p {
        text-align: justify;
      }

      & a {
        color: #0275d8;

        &:hover {
          color: #014c8c;
        }
      }
    }

    &-title {
      font-size: 32px;
      margin-top: 80px;
      text-align: center;
    }
  }
}

@media screen and (max-width: 575px) {


  .tp-show__list {

    &-item {

      &_person {
        width: 100% !important;
      }
    }
  }
}

.swiper-button {

  &-next, &-prev {
    color: #fff !important;
    opacity: .7 !important;

    &:hover {
      opacity: 1 !important;
    }
  }
}

@media (max-width: 510px) {
  .swiper-button-next,
  .swiper-button-prev {
    display: none;
  }
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  pointer-events: all !important;
  display: none;
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  pointer-events: all !important;
  display: none;
}
</style>
